export const toggleGroupVisibility = (
  groupId: string, //uuid
  expandedGroups: string[],
  setExpandedGroups: React.Dispatch<React.SetStateAction<string[]>>
) => {
  if (expandedGroups.includes(groupId)) {
    setExpandedGroups(expandedGroups.filter((group) => group !== groupId));
  } else {
    setExpandedGroups([...expandedGroups, groupId]);
  }
};
